export default "__VITE_ASSET__D$$rkPL___"